module.exports = __webpack_public_path__ + "static/media/apply-substitution.8ab192eb.svg";